import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./config/Store";
import "./i18n/config";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";
import GlobalSeo from "./components/Common/SEO/GlobalSeo";

let persistor = persistStore(store);

// The /egress-template route is loaded by the LiveKit recording bot, not a
// human — it must never show the browser notification-permission prompt (it
// would appear in the recording) or register the FCM service worker.
const isEgressTemplate =
  window.location.pathname.startsWith("/egress-template");

if (!isEgressTemplate && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("✅ FCM SW registered", registration);

    })
    .catch((error) => {
      console.error("❌ SW registration failed", error);

    });
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
if (!isEgressTemplate && "Notification" in window) {
  Notification.requestPermission().then((permission) => {
    console.log("🔔 Notification permission:", permission);
  });
}

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <GlobalSeo />
          <React.Suspense fallback={<div>Loading...</div>}>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ""}>
              <App />
            </GoogleOAuthProvider>
          </React.Suspense>
        </BrowserRouter>
      </PersistGate>
    </HelmetProvider>
  </Provider>
);
